export const regexZipCode = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/;
